/* declaration */
gsap.registerPlugin(ScrollTrigger);

/** START -- for stikcy header  **/
window.addEventListener('scroll', function(){document.querySelector('#shopify-section-header').classList.toggle("header-sticky", window.scrollY > 100);});
/** END -- for stikcy header **/

/* *
video play on scroll
*/

gsap.utils.toArray(".v0").forEach((video) =>
	videoScrub(video, {
		scrollTrigger: {
			trigger: document.querySelector(".scrollVideo_wrap"),
			start: "center center",
			end: "+=600",
			markers: false,
			scrub: true,
			pin: true
		}
	})
);

function videoScrub(video, vars) {
	video = gsap.utils.toArray(video)[0]; // in case selector text is fed in.
	let once = (el, event, fn) => {
			let onceFn = function () {
				el.removeEventListener(event, onceFn);
				fn.apply(this, arguments);
			};
			el.addEventListener(event, onceFn);
			return onceFn;
		},
		prepFunc = () => {
			video.play();
			video.pause();
		},
		prep = () => once(document.documentElement, "touchstart", prepFunc),
		src = video.currentSrc || video.src,
		tween = gsap.fromTo(
			video,
			{ currentTime: 0 },
			{
				paused: true,
				immediateRender: false,
				currentTime: video.duration || 1,
				ease: "none",
				...vars
			}
		),
		resetTime = () =>
			(tween.vars.currentTime = video.duration || 1) && tween.invalidate();
	prep();
	video.readyState ? resetTime() : once(video, "loadedmetadata", resetTime);
	return tween;
}


/* *
END here*/

/* prodcut page js animation */ 
  gsap.from(".wrapper .box", {
    y: 100,
    duration: 0.5,
    scale: 0.9,
    stagger: {
      each: 0.5
    },
    repeat: -1,
  });
  
  /*Razor scroll animation*/
  const animationWrap = document.querySelector("#product\.for-razors\ #shopify-section-template--16540790161643__1663661215f36d715a");
  const animationWrapInner = document.querySelector(".animation-wrap");
  
  if(animationWrapInner){
    const hairs = animationWrapInner.querySelector(".hairs-wrap");
    const razor = animationWrapInner.querySelector(".razor-wrap");
  
    // if(hairs && razor){
      gsap.set(hairs,{ y:200,scale:1.5,});
      gsap.set(razor,{ y:-600,});
      
      gsap.to(hairs, {
          // y: 100,
          opacity: 0,
          scrollTrigger: {
              trigger: animationWrap,
              // start: "top bottom",
              // end: "top 100px",
              scrub: true,
              // markers: true,
              id : "Hairs",
              // pin:true,
              pinSpacing: false
          }
      });
      
      gsap.to(razor, {
          y: 0,
          scrollTrigger: {
              trigger: animationWrapInner,
              start: "top 70%",
              end: "50% 0%",
              scrub: true,
              // markers: true,
              id : "Razor",
              // pin:true,
              pinSpacing: false
          }
      });
      
    // }
  }
/*END here*/
/* swiper js */
var swiper = new Swiper(".mySwiper", {
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    // },
    speed: 600,
    // freeMode: true,
    grabCursor: true,
    mousewheel: {
      enabled: true,
      sensitivity: 5.5,
      releaseOnEdges: true,
    },
    // slidesPerView: 2,
    // spaceBetween: 30,
    breakpoints: {
        991: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
});

// Razor Colors
let razorColorSwiperThumb = new Swiper(".razorColorSwiperThumb", {
	spaceBetween: 10,
	slidesPerView: "auto",
	freeMode: true,
	watchSlidesProgress: true,
    direction: "vertical",
});
let razorColorSwiper = new Swiper(".razorColorSwiper", {
	spaceBetween: 10,
	slidesPerView: 1,
    // direction: "vertical",
    grabCursor: true,
    mousewheel: {
      enabled: true,
      sensitivity: 5.5,
      releaseOnEdges: true,
    },
	thumbs: {
		swiper: razorColorSwiperThumb
	}
});
/* Razor Types of usage */
let typesOfUseSwiperThumb = new Swiper(".typesOfUseSwiperThumb", {
	spaceBetween: 10,
	slidesPerView: "auto",
	freeMode: true,
	watchSlidesProgress: true,
    // direction: "vertical",
});
let typesOfUseSwiper = new Swiper(".typesOfUseSwiper", {
	spaceBetween: 10,
	slidesPerView: 1,
    // direction: "vertical",
    grabCursor: true,
    mousewheel: {
      enabled: true,
      sensitivity: 5.5,
      releaseOnEdges: true,
    },
	thumbs: {
		swiper: typesOfUseSwiperThumb,
	}
});
